import React, { ReactElement, ReactNode } from 'react';

import { NavigationCenterTools } from 'dogpark/components';
import { Layout } from 'shared/components/layout/Layout';

import { DogParkLayoutStyled } from './DogParkLayout.styles';

interface Props {
  children: ReactNode;
}

function DogParkLayout(props: Props): ReactElement {
  const { children } = props;

  return (
    <DogParkLayoutStyled>
      <Layout navigationCenterTools={<NavigationCenterTools />}>{children}</Layout>
    </DogParkLayoutStyled>
  );
}

export default DogParkLayout;
